import React from 'react';
import { useConnectionStatus } from '../Components/ConnectionStatusProvider';

const AuthLoadingScreen: React.FC = () => {
  const { status } = useConnectionStatus();

  const message = status?.message || 'Authenticating…';
  const isError = status?.success === false && status?.message?.toLowerCase().includes('fail');

  return (
    <div
      className="fixed inset-0 flex flex-col items-center justify-center z-[200]"
      style={{ background: '#09090e' }}
    >
      {/* Ambient glow */}
      <div
        className="absolute pointer-events-none"
        style={{
          top: '30%', left: '50%', transform: 'translate(-50%,-50%)',
          width: '400px', height: '400px', borderRadius: '50%',
          background: 'radial-gradient(circle,rgba(99,102,241,0.12),transparent)',
          filter: 'blur(60px)',
        }}
      />

      <div className="relative z-10 flex flex-col items-center gap-6 text-center px-6 max-w-sm">
        {/* Logo */}
        <div
          className="w-12 h-12 rounded-[12px] flex items-center justify-center font-black text-[15px] text-white shadow-lg"
          style={{
            background: 'linear-gradient(135deg,#6366f1,#a855f7)',
            fontFamily: "'Syne',sans-serif",
          }}
        >
          Qx
        </div>

        {/* Spinner */}
        {!isError && (
          <div className="relative w-10 h-10">
            <div
              className="absolute inset-0 rounded-full animate-spin"
              style={{
                border: '2px solid #26262f',
                borderTopColor: '#6366f1',
              }}
            />
          </div>
        )}

        {/* Error icon */}
        {isError && (
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center"
            style={{ background: 'rgba(244,63,94,0.1)', border: '1px solid rgba(244,63,94,0.3)' }}
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="#f43f5e" strokeWidth="1.5">
              <circle cx="9" cy="9" r="7.5"/><path d="M9 5v4M9 12v.5"/>
            </svg>
          </div>
        )}

        {/* Status message */}
        <div>
          <p
            className="text-[14px] font-medium"
            style={{ color: isError ? '#f43f5e' : '#eeeef5' }}
          >
            {message}
          </p>
          {!isError && (
            <p className="text-[12px] mt-1.5" style={{ color: '#52525f' }}>
              Please wait, do not close this tab
            </p>
          )}
          {isError && (
            <p className="text-[12px] mt-1.5" style={{ color: '#52525f' }}>
              Please go back and try again
            </p>
          )}
        </div>

        {/* Animated step dots */}
        {!isError && (
          <div className="flex gap-1.5">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className="w-1.5 h-1.5 rounded-full"
                style={{
                  background: '#6366f1',
                  animation: `pulse 1.2s ease-in-out ${i * 0.2}s infinite`,
                }}
              />
            ))}
          </div>
        )}
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 0.2; transform: scale(0.8); }
          50% { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default AuthLoadingScreen;